var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef } from "react";
import PasswordGroup from "./PasswordGroup";
import Password from "./Password";
import PasswordDisplay from "./PasswordDisplay";
import PasswordDisplayLabel from "./PasswordDisplayLabel";
import { HintText, Input, Label, Message, MessagesGroup } from "../../Form";
var PasswordControl = forwardRef(function (_a, ref) {
    var id = _a.id, name = _a.name, label = _a.label, hintText = _a.hintText, messages = _a.messages, passwordForget = _a.passwordForget, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "name", "label", "hintText", "messages", "passwordForget", "className", "style"]);
    var _b = useState(false), isPasswordVisible = _b[0], setIsPasswordVisible = _b[1];
    var handleTogglePasswordVisibility = function () {
        setIsPasswordVisible(function (prevState) { return !prevState; });
    };
    return (React.createElement(PasswordGroup, { id: id },
        React.createElement(Label, { className: "fr-label", htmlFor: "".concat(id, "-input") },
            label,
            hintText && React.createElement(HintText, null, hintText)),
        React.createElement(Password, __assign({}, otherProps, { ref: ref, className: className, style: style, name: name, "aria-describedby": "".concat(id, "-input-messages"), "aria-required": true, id: "".concat(id, "-input"), type: isPasswordVisible ? "text" : "password" })),
        React.createElement(MessagesGroup, { id: "".concat(id, "-input-messages") }, messages &&
            messages.map(function (msg, index) { return (React.createElement(Message, { key: index, className: "".concat(msg.state ? "fr-message--".concat(msg.state) : ""), id: msg.id }, msg.children)); })),
        React.createElement(PasswordDisplay, null,
            React.createElement(Input, { "aria-label": "Afficher le mot de passe", id: "".concat(id, "-show"), type: "checkbox", checked: isPasswordVisible, onChange: handleTogglePasswordVisibility, name: "" }),
            React.createElement(PasswordDisplayLabel, { htmlFor: "".concat(id, "-show") }, "Afficher")),
        passwordForget && React.createElement("p", null, passwordForget)));
});
export default PasswordControl;
